<template>
	<!--相关疾病-->
	<div class="box" v-if="xgjbBool">
		 <div class="content">
		 	<div class="header">
		 		相关疾病
		 	</div>
		 	<div class="tabBtn">
		 		<div class="btn" v-for="item in showItem" :class="{'active':keyId==item.id}" @click="tabBtnClick($event,item.id,item.tName)" >{{item.tName}}</div>
		 		<!--:"-->
		 		<div class="zkBtn" v-show="!showAll&&keyNamearr.length>3">
	 				<span>···</span>
	 				<span @click="showAll=!showAll">展开<i class="bkjt active"></i></span>
	 			</div>
	 			<div class="zkBtn" v-show="showAll&&keyNamearr.length>3" @click="showAll=!showAll">
	 				<span></span>
	 				<span><i class="bkjt active1"></i>收起</span>
	 			</div>
		 	</div>
		 	<div class="textTab">
		 		<div @click="textTabClick($event,1)" class="active">概述</div>
		 		<div @click="textTabClick($event,2)">病因症状</div>
		 		<div @click="textTabClick($event,3)">治疗预防</div>
		 		<div @click="textTabClick($event,4)">相关视频</div>
		 		<!--<div>病友说</div>-->
		 		<!-- @click="textTabClick($event,5)"-->
		 	</div>
		 	<div class="textCentent">
		 		<div class="gs" v-show="textNum==1" >
		 			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{words_row.kGS}}
		 		</div>
		 		<div class="by" v-show="textNum==2">
		 			<span :class="{'active':zk1Bool}">
		 				<pre>{{words_row.kBYZZ}}</pre>
		 			</span>
		 			<div class="zk" v-show="zk1Bool" @click="showmore1">
		 				<span>展开<i class="bkjt active"></i></span>
		 			</div>
		 			<div class="zk" v-show="!zk1Bool" @click="showmore1">
		 				<span><i class="bkjt active1"></i>收起</span>
		 			</div>
		 		</div>
		 		<div class="yf" v-show="textNum==3" >
		 			<span :class="{'active':zk2Bool}">
		 				<pre>{{words_row.kZLYF}}</pre>
		 			</span>
		 			<div class="zk" v-show="zk2Bool" @click="showmore2">
		 				<span>展开<i class="bkjt active"></i></span>
		 			</div>
		 			<div class="zk" v-show="!zk2Bool" @click="showmore2">
		 				<span><i class="bkjt active1"></i>收起</span>
		 			</div>
		 		</div>
		 		<div class="videoList" v-show="textNum==4">
		 			<div class="videoBox" v-for="item in showItem1" @click="playVideo(item.vPath)" v-if="item.tName==tNameVal">
						<div>
							<img :src="item.vTitleImg" alt="" />
						</div>
						<div>
							<span>{{item.vTitle}}</span>
							<p>{{item.vRemark}}</p>
						</div>
					</div>
					<div class="zk" v-show="!showAll1&&videoList.length>1" @click="showAll1=!showAll1">
		 				<span>展开<i class="bkjt active"></i></span>
		 			</div>
		 			<div class="zk" v-show="showAll1&&videoList.length>1" @click="showAll1=!showAll1">
		 				<span><i class="bkjt active1"></i>收起</span>
		 			</div>
		 		</div>
		 	</div>
		 </div>
		<div class="dialogVideo" v-if="videobool">
			<iframe frameborder="0" :src="videoSrc" allowFullScreen="true"></iframe>
			<i class="el-icon-circle-close" @click="playVideogb"></i>
		</div>
	</div>
</template>

<script>
	import {get_wikis,keywords_types_list,keywords_row,keywords_videos_list} from '../components/http/api.js'
	export default{
		data(){
			return{
				textNum:1,
				xgjbBool:true,
				keyNamearr:[],
				keyId:'',
				words_row:{},
				videoList:[],
				tNameVal:'',
				videoSrc:'',
				videobool:false,
				zk1Bool:true,
				zk2Bool:true,
				showAll:false,
				showAll1:false
				
			}
		},
		mounted(){
			this.keywords_types_listFn();
		},
		methods:{
			tabBtnClick(event,id,name){
				var el = event.currentTarget;
				$(el).addClass('active');
				$(el).siblings().removeClass('active');
				this.keyId=id;
				this.keywords_rowFn(id);
				this.tNameVal=name;
			},
			textTabClick(event,num){
				var el = event.currentTarget;
				this.textNum=num;
				$(el).addClass('active');
				$(el).siblings().removeClass('active');
			},
			playVideo(src){
				this.videoSrc=src;
				this.videobool=true;
			},
			playVideogb(){
				this.videoSrc='';
				this.videobool=false;
			},
			keywords_types_listFn(){
				var data={
					keyName:this.$route.query.val,
					wno:this.$route.query.wno
				}
				keywords_types_list(data).then(res=>{
					if(res.data==''){
						this.xgjbBool=false;
					}else{
						this.keyNamearr=res.data;
						this.keyId=res.data[0].id;
						this.keywords_rowFn(res.data[0].id);
						this.tNameVal=res.data[0].tName;
						this.videoList=res.list_video;
					}
				})
			},
			keywords_rowFn(id){
				var data={
					keyName:this.$route.query.val,
					id:id
				}
				keywords_row(data).then(res=>{
					this.words_row=res.row;
				})
			},
			keywords_videos_rowFn(id){
				var data={
					id:id,
				}
				keywords_videos_row(data).then(res=>{

				})
			},
			showmore1(){
			    this.zk1Bool = !this.zk1Bool;
			},
			showmore2(){
			    this.zk2Bool = !this.zk2Bool;
			},

		},
		computed: {
   			 showItem() {
			    if (this.showAll == false) { //当数据不需要完全显示的时候
			        var showItem = [];　　　　　//定义一个空数组
			        if (this.keyNamearr.length > 3) {　//这里我们先显示前四个
			          for (var i = 0; i < 3; i++) {
			            showItem.push(this.keyNamearr[i])
			          }
			        } else {
			          showItem = this.keyNamearr
			        }
			        return showItem;　//返回当前数组
			      } else {
			        return this.keyNamearr;
			      }
			},
			showItem1() {
			    if (this.showAll1 == false) { //当数据不需要完全显示的时候
			        var showItem1 = [];　　　　　//定义一个空数组
			        if (this.videoList.length > 3) {　//这里我们先显示前四个
			          for (var i = 0; i < 3; i++) {
			            showItem1.push(this.videoList[i])
			          }
			        } else {
			          showItem1 = this.videoList
			        }
			        return showItem1;　//返回当前数组
			      } else {
			        return this.videoList;
			      }
			},
			
		}
	}
</script>

<style scoped="scoped">
	.header{
		margin: 0 30px;
		margin-top: 60px;
		font-size:50px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(98,97,98,1);
		line-height:50px;
		letter-spacing:1px;
	}
	.tabBtn{
		margin: 0 30px;
		margin-top: 40px;
		display: flex;
		justify-content: flex-start;
	  	flex-wrap:wrap;
	}
	.tabBtn>div.btn{
		/*width:160px;*/
		padding: 0 40px;
		height:60px;
		background:rgba(242,247,250,1);
		border-radius:30px;
		text-align: center;
		cursor: pointer;
		font-size:26px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(155,155,155,1);
		line-height:60px;
		margin-right:15px;
		margin-bottom: 20px;
		/*float: left;*/
	}
	.tabBtn>div.btn:nth-child(4){
		margin-right: 0 !important;
	}
	.tabBtn>div.btn.active{
		/*width:160px;*/
		height:60px;
		background:rgba(96,203,255,1);
		border-radius:30px;
		font-size:26px;
		font-weight:600 !important;
		color:rgba(255,255,255,1);
	}
	.textTab{
		margin-top: 60px;
		padding: 0 30px;
		border-bottom: 1px solid #EAEAEA;
		display: flex;
		justify-content: space-around;
	}
	.textTab>div{
		font-size:28px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(74,74,74,1);
		padding-bottom: 13px;
		cursor: pointer;
	}
	.textTab>div.active{
		font-weight:600 !important;
		color:rgba(74,74,74,1);
		position: relative;
	}
	.textTab>div.active::before{
		content: "";
		display:block;
		width:100%;
		height:5px;
		background:#9B9B9B;
		border-radius:4px 4px 0px 0px;
		position: absolute;
		bottom: 0;
	}
	.textCentent{
		margin: 0 50px;
		margin-top: 30px;
	}
	.gs{
		font-size:28px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(155,155,155,1);
		line-height:48px;
	}
	.by,.yf{
		font-size:28px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(155,155,155,1);
		line-height:48px;
		position: relative;
		margin-bottom: 50px;
	}
	.by>span:nth-child(1).active,.yf>span:nth-child(1).active{
		/*height: 235px;*/
		display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        -webkit-line-clamp: 5; /*显示的行数；如果要设置2行加...则设置为2*/
        overflow: hidden;
        text-overflow: ellipsis; /* 溢出用省略号*/
        -webkit-box-orient: vertical;/*伸缩盒子的子元素排列：从上到下*/
	}
	.bkjt{
		display: block;
		width: 20px;
		height: 17px;
		background: url(../assets/image/bkjt.png) no-repeat center center;
		background-size:100% ;
	}
	.bkjt.active{
		margin-left: 5px;
		transform: rotate(180deg);
	}
	.bkjt.active1{
		margin-right: 5px;
	}
	.zk{
		/*position: absolute;
		bottom: 0;
		right: 0;*/
		background: #FFFFFF;
		display: flex;
		float: right;
	}
	.zkBtn{
		/*width: 140px;*/
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	.zkBtn>span:nth-child(1){
		font-size:26px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(155,155,155,1);
		margin-left:50px ;
		margin-right: 20px;
		line-height: 60px;
	}
	.zk>span:nth-child(1){
		width: 88px;
		font-size:28px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:#1DB5FF;
		border-bottom:1px solid #1DB5FF;
		display: flex;
		align-items: center;
	}
	.zkBtn>span:nth-child(2){
		width: 88px;
		height: 60px;
		font-size:28px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:#1DB5FF;
		display: flex;
		align-items: center;
	}
	span.active{
		/*height: auto;*/
	}
	.videoBox{
		height: 190px;
		overflow: hidden;
		display: flex;
		border-top:1px solid rgba(155,155,155,0.23) ;
	}
	.videoList{
		position: relative;
		margin-bottom: 40px;
	}
	.videoList>.videoBox:first-child{
		border-top:none !important;
	}
	.videoList>.zk{
		position: absolute;
		bottom: -10px;
		right: 0;
	}
	.videoBox>div:nth-child(1){
		width:250px;
		height:140px;
		background:#EAEAEA;
		border-radius:3px;
		text-align: center;
		line-height: 140px;
		overflow: hidden;
		margin-right: 50px;
		margin-top: 25px;
	}
	.videoBox>div:nth-child(1)>img{
		width:250px;
	}
	.videoBox>div:nth-child(2){
		width:410px;
		margin-top: 25px;
	}
	.videoBox>div:nth-child(2)>span{
		display: block;
		font-size:28px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:600;
		color:rgba(74,74,74,1);
		line-height:30px;
		margin-top: 10px;
	}
	.videoBox>div:nth-child(2)>p{
		font-size:24px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:30px;
		margin-top: 20px;
		
	}
	.dialogVideo{
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0,0,0,.5);
		width: 100%;
		height: 100%;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.dialogVideo>i{
		font-size:30px;
		display: block;
		width: 50px;
		height: 50px;
		background: url(../assets/image/clear.png) no-repeat center center;
		background-size:100% ;
		position: absolute;
		top: 20px;
		right: 8%;
		border-radius: 50%;
		cursor: pointer;
	}
	.dialogVideo>iframe{
		width: 80%;
		height: 30%;
	}
</style>


// WEBPACK FOOTER //
// src/component/relatedDiseases.vue